export default "__VITE_ASSET__86FfRj7A__"